// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackSubmitReturnRequestParameters extends TrackEventBaseParameters {}

const trackSubmitReturnRequest = (
    parameters: TrackSubmitReturnRequestParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "submit_return_request", ...parameters }, options);
};

export default trackSubmitReturnRequest;
